import { apiSlice } from "./apiSlice";
import { setUnitOfMeasureSelection, setUnitOfMeasures } from "../slice/unitOfMeasureSlice";

export const unitOfMeasureApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUnitOfMeasures: builder.query({
      query: (params = null) =>
        params ? `/api/uom/v1/unit_of_measure/?${params}` : "/api/uom/v1/unit_of_measure/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setUnitOfMeasures(result.data))).catch(error => {});
      },
      providesTags: ["unitOfMeasureList", "UnitOfMeasure"],
    }),
    getUnitOfMeasureSelection: builder.query({
      providesTags: ["UnitOfMeasure"],
      query: (params = null) => {
        const queryStr = typeof params === "string" ? params : params?.params;
        return queryStr
          ? `/api/uom/v1/unit_of_measure/selection/?${queryStr}`
          : "/api/uom/v1/unit_of_measure/selection/";
      },
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setUnitOfMeasureSelection(result.data)))
          .catch(error => {});
      },
    }),
    getUnitOfMeasureById: builder.query({
      providesTags: ["UnitOfMeasure"],
      query: id => `/api/uom/v1/unit_of_measure/${id}/`,
    }),
    createUnitOfMeasure: builder.mutation({
      query: data => ({
        url: "/api/uom/v1/unit_of_measure/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["unitOfMeasureList", "UnitOfMeasure"],
    }),
    updateUnitOfMeasure: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/uom/v1/unit_of_measure/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["unitOfMeasureList", "UnitOfMeasure"],
    }),
  }),
});

export const {
  useGetUnitOfMeasuresQuery,
  useLazyGetUnitOfMeasuresQuery,
  useGetUnitOfMeasureSelectionQuery,
  useLazyGetUnitOfMeasureSelectionQuery,
  useGetUnitOfMeasureByIdQuery,
  useCreateUnitOfMeasureMutation,
  useUpdateUnitOfMeasureMutation,
} = unitOfMeasureApiSlice;
